import React, { useState } from 'react';
import './PrivacyPolicy.css';

const sections = [
  {
    title: 'A. Personal Information We Collect',
    content: 'We collect personal information from our users when they register on our platform, including their name and phone number, email address, and other contact information. We also collect information about their educational background, interests, and other preferences. This information helps us tailor our platform to their needs. '
  },
  {
    title: 'B. How We Use Personal Information',
    content: `We use personal information of the users internally to improve and tailor our platform according to their needs. We might also provide this information to AI agents to tailor its responses to the users.
    
    We may also use personal information for research and analysis purposes to improve our platform and educational resources.
    `
  },
  {
    title: 'C. How We Protect Personal Information',
    content: `We take appropriate security measures to protect personal information from unauthorized access, use, disclosure, or alteration. We use encryption technologies and access controls to ensure the confidentiality and integrity of personal information.

We also limit access to personal information to only those employees, contractors, and service providers who need access to it to provide our services.`
  },
  {
    title: 'D. Disclosure of Personal Information',
    content: `We do not sell or rent personal information to third parties. However, we may disclose personal information to our partners, service providers, and contractors who assist us in providing our services.

We may also disclose personal information if required by law or if we believe in good faith that disclosure is necessary to protect our rights, property, or safety or that of our users.`
  },
  {
    title: 'E. User Rights',
    content: `Our users have the right to access, update, or delete their personal information at any time. Users may also opt-out of receiving promotional emails from us.`
  },
  {
    title: 'F. Contact Us',
    content: 'If you have any questions or concerns about our Privacy Policy or how we handle personal information, please contact us at [support@k2neet.com].'
  }
];

export default function PrivacyPolicy() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleAccordion = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <div className="privacy-policy-container">
      <div className="privacy-policy-card">
        <h1>Privacy Policy</h1>
        <h2>Privacy Policy</h2>
        <p>
          This Privacy Policy outlines how our app collects, uses, and protects the personal information of our users. The privacy of our users is important to us, and we take the responsibility of safeguarding their personal information seriously.
        </p>
      </div>
      <div className="privacy-policy-accordion-section">
        {sections.map((section, idx) => (
          <div key={section.title} className="accordion-item">
            <button className="accordion-title" onClick={() => toggleAccordion(idx)}>
              {section.title}
              <span className="accordion-arrow">{openIndex === idx ? '▲' : '▼'}</span>
            </button>
            {openIndex === idx && (
              <div className="accordion-content">{section.content}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
} 